import * as React from "react";
export function EditPencil(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
      <path d="M12.3 3.7l4 4L4 20H0v-4L12.3 3.7zm1.4-1.4L16 0l4 4-2.3 2.3-4-4z" />
    </svg>
  );
}

export function Trashbin(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
      fill={"currentcolor"}
      {...props}
    >
      <path d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z" />
    </svg>
  );
}

export function CloseIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 512 512"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
      <path d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z" />
    </svg>
  );
}
export function AddIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" viewBox="0 0 15 15" height="1em" width="1em" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7 7V4h1v3h3v1H8v3H7V8H4V7h3z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export function FolderIcon(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13.099"
      height="11.889"
      viewBox="0 0 13.099 11.889"
      {...props}
    >
      <path
        id="Icon_feather-folder"
        data-name="Icon feather-folder"
        d="M13.889,15.889H4.21a1.712,1.712,0,0,1-1.71-1.71V5.71A1.712,1.712,0,0,1,4.21,4H7.235a.5.5,0,0,1,.416.223L8.712,5.815h5.177a1.712,1.712,0,0,1,1.71,1.71v6.654A1.712,1.712,0,0,1,13.889,15.889ZM4.21,5a.711.711,0,0,0-.71.71v8.469a.711.711,0,0,0,.71.71h9.679a.711.711,0,0,0,.71-.71V7.525a.711.711,0,0,0-.71-.71H8.445a.5.5,0,0,1-.416-.223L6.967,5Z"
        transform="translate(-2.5 -4)"
      />
    </svg>
  );
}
